<!--desktop version -->
<div
  data-at-item
  *ngIf="!asDropdown"
  class="vi-item flex flex-col lt-md:!hidden"
  [class.inversed]="inversed"
>
  <div data-at-title class="title title--icon">
    <span>
      {{ title }}
    </span>
    <vi-icon
      *ngIf="tooltipText"
      [matTooltip]="tooltipText"
      [size]="14"
      name="info"
      class="label-icon"
    >
    </vi-icon>
  </div>
  <div class="flex flex-row">
    <div
      data-at-value
      *ngIf="isValue() && !stackValuesVertically"
      class="value {{ color }} {{ size }} flex flex-row gap-[16px]"
      [class.error]="error"
    >
      <span>
        {{ disableNumberFormatting ? value : unitsAdapter.getDisplayValue(value, unit) }}
        {{ unitsAdapter.getSuffix(unit) }}</span
      >
    </div>
    <div *ngIf="stackValuesVertically">
      <div *ngFor="let item of value">
        {{ unitsAdapter.getDisplayValue(item, unit) }}{{ unitsAdapter.getSuffix(unit) }}
      </div>
    </div>
  </div>
</div>
<!--mobile version-->
<div
  data-at-item
  *ngIf="!asDropdown"
  class="vi-item flex flex-col gt-sm:!hidden"
  [class.inversed]="inversed"
>
  <div data-at-title class="title">
    {{ title }}
  </div>
  <div class="flex flex-row">
    <div
      data-at-value
      *ngIf="isValue() && !stackValuesVertically"
      class="value {{ color }} {{ size }} flex flex-row gap-[16px]"
      [class.error]="error"
    >
      <span
        >{{ unitsAdapter.getDisplayValue(value, unit) }} {{ unitsAdapter.getSuffix(unit) }}</span
      >
    </div>
    <div *ngIf="stackValuesVertically">
      <div *ngFor="let item of value">
        {{ unitsAdapter.getDisplayValue(item, unit) }} {{ unitsAdapter.getSuffix(unit) }}
      </div>
    </div>
    <vi-icon
      *ngIf="tooltipText"
      [matTooltip]="tooltipText"
      #tooltip="matTooltip"
      [size]="14"
      name="info"
      class="label-icon"
      (click)="tooltip.toggle()"
    >
    </vi-icon>
  </div>
</div>
<!-- dropdown -->
<div
  data-at-dropdown
  *ngIf="asDropdown"
  class="vi-dropdown flex flex-col"
  [class.inversed]="inversed"
  matTooltip="{{ tooltipText }}"
  matTooltipPosition="above"
  [matTooltipDisabled]="!tooltipText"
>
  <mat-form-field
    [attr.mat-select-height-large]="sizeOfDropdownBox === 'large' ? '' : null"
    [attr.mat-select-height-medium]="sizeOfDropdownBox === 'medium' ? '' : null"
    [attr.mat-select-height-small]="sizeOfDropdownBox === 'small' ? '' : null"
    data-at-dropdown
  >
    <mat-label data-at-title>{{ title }}</mat-label>
    <mat-select
      data-at-dropdown-select
      [ngModel]="currentOptionValue"
      (ngModelChange)="onValueChange($event)"
    >
      <mat-option
        data-at-option
        *ngFor="let option of options"
        [value]="option.value"
        [disabled]="option.value === incorrectValue"
        matTooltip="{{
          option.value === incorrectValue ? ('GENERAL.SELECT_VALUE_INCORRECT' | translate) : ''
        }}"
      >
        <ng-container *ngIf="unit; else viewValue"
          >{{ unitsAdapter.getDisplayValue(option.value, unit) }} {{ unitsAdapter.getSuffix(unit) }}
        </ng-container>
        <ng-template #viewValue>{{ option.viewValue }}</ng-template>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
